


































































import { isValidUsername } from "@/utils/validate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { Route } from "vue-router";
import { ElForm } from "element-ui/types/form";
import {
  GetEmailCodeReq,
  getEmailCode,
  ForgetPasswordReq,
  forgetPassword
} from "@/api/admin";
import { ResCode } from "@/api/baseDefine";
import { setInterval, clearInterval } from "timers";

@Component
export default class ForgetPassword extends Vue {
  private sendEmail = "";
  private timer;
  private count = 0;
  private type = "primary";
  private validateEmail(rule: any, value: string, callback: any) {
    callback();
  }
  private validatePass(rule: any, value: string, callback: any) {
    if (value.length < 8) {
      callback(
        new Error(this.$t("validate.passwordMustGreaterThan8").toString())
      );
    } else {
      callback();
    }
  }

  private validatePass2(rule: any, value: string, callback: any) {
    if (value !== this.dataForm.password) {
      callback(new Error(this.$t("validate.twoPasswordNotEqual").toString()));
    } else {
      callback();
    }
  }
  private url =
    "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg";
  public dataForm = {
    email: "",
    password: "",
    confirmPassword: "",
    code: ""
  };
  public dataRules = {
    password: [
      { required: true, trigger: "blur", validator: this.validatePass }
    ],
    confirmPassword: [
      { required: true, trigger: "blur", validator: this.validatePass2 }
    ]
  };
  private loading = false;
  private pwdType = "password";
  private redirect: string | undefined = undefined;

  @Watch("$route", { immediate: true })
  private OnRouteChange(route: Route) {
    // TODO: remove the "as string" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    this.redirect = route.query && (route.query.redirect as string);
  }

  private showPwd() {
    if (this.pwdType === "password") {
      this.pwdType = "";
    } else {
      this.pwdType = "password";
    }
  }

  public created() {
    this.sendEmail = this.$t("login.sendCode").toString();
  }

  public async sendEmaliCode() {
    if (!!this.timer && this.count > 0) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.emailCodeAlreadySend").toString(),
        type: "warning"
      });
      return;
    }
    let req = <GetEmailCodeReq>{ type: 1, email: this.dataForm.email };
    const res = await getEmailCode(req);
    if (res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.getEmailSuccess").toString(),
        type: "success"
      });
      this.count = 60;
      let self = this;
      self.sendEmail = self.count.toString();
      self.type = "primary";
      this.timer = setInterval(function() {
        if (self.count <= 0) {
          self.sendEmail = self.$t("login.sendCode").toString();
          clearInterval(self.timer);
          self.type = "danger";
          self.timer = null;
          return;
        }
        self.count--;
        self.sendEmail = self.count.toString();
      }, 1000);
    } else {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.getEmailError").toString(),
        type: "warning"
      });
    }
  }

  public async forgetPassword() {
    (this.$refs.dataForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.requesForgetPassword();
      } else {
        return false;
      }
    });
  }

  public async requesForgetPassword() {
    let req = <ForgetPasswordReq>{
      email: this.dataForm.email,
      emailCode: this.dataForm.code,
      password: this.dataForm.password,
      comfirmPassword: this.dataForm.confirmPassword
    };
    const res = await forgetPassword(req);
    if (res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.changePasswordSuccess").toString(),
        type: "success"
      });
      this.$router.push('/login')
    }
  }
}
